import React, { Component } from "react";
import Navigation, { NavItem } from "../../components/Navigation";
import { SubNavItem } from "../../components/SubNavigation";
import Footer from "../../components/Footer";
import ContentBlocks from "../../components/ContentBlocks";
import "../DefaultPage/style.scss";

type PropsType = {
    mainNav?: Array<NavItem>;
    subNav?: Array<SubNavItem>;
    theme?: ThemeType;
    blocks?: Array<Object>;
    footer?: {
        column1: string;
        column2: string;
        column3: string;
    };
};

type ThemeType = {
    fill: string;
    text: string;
    type: "dark" | "light";
};

class DefaultPage extends Component<PropsType, {}> {
    public render() {
        const mainNav = this.props.mainNav ? this.props.mainNav : [];
        const subNav = this.props.subNav ? this.props.subNav : undefined;
        const blocks = this.props.blocks ? this.props.blocks : [];
        const subNavClass = this.props.subNav && this.props.subNav.length > 0 ? " DefaultPage--with-subnav" : "";
        const themeClass = this.props.theme && this.props.theme.fill !== "inherit" ? " DefaultPage--with-theme" : "";
        const className = `DefaultPage${subNavClass}${themeClass}`;

        return (
            <div className={className}>
                <Navigation items={mainNav} subItems={subNav} theme={this.props.theme} />
                <ContentBlocks blocks={blocks} theme={this.props.theme} />
                <Footer
                    col1={this.props.footer.column1}
                    col2={this.props.footer.column2}
                    col3={this.props.footer.column3}
                />
            </div>
        );
    }
}

export default DefaultPage;
